import guard from '@/guard'

const statusesWhenDispatcherCantEdit = ['cancelled', 'done']

const canEditOrder = (order, roles = []) => {
  if (!order) {
    return false
  }

  if (order.status === 'draft') {
    return true
  }

  if (guard.hasAtLeastOneRole(roles, ['ROLE_ADVANCED_DISPATCHER'])) {
    return true
  }

  if (guard.hasAtLeastOneRole(roles, ['ROLE_DISPATCHER'])
    && !statusesWhenDispatcherCantEdit.includes(order.status)
    && !order.patientOnBoard) {
    return true
  }

  return false
}

export default canEditOrder
